export default function TableRow() {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-of-type': {
            '& .MuiTableCell-root': {
              // borderBottom: 'none',
            },
          },
        },
      },
    },
  };
}
